module.exports = __webpack_public_path__ + "img/screen-with-photo.234649fd.svg";